import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl';
import { Card } from '@salesforce/design-system-react';
import { ClassDetailsChart, ClassStats } from '../';

import './ClassDetails.scss';

class ClassDetails extends Component {
  render() {
    const COUNTER = { selectionCount: 0, fallbackCount: 0, einsteinCount: 0 };
    const total = this.props.details.reduce((counter, slice) => {
      counter.selectionCount += slice.selections_total;
      counter.fallbackCount += slice.fallback_total;
      counter.einsteinCount =
        counter.selectionCount - (counter.fallbackCount || 0);
      return counter;
    }, COUNTER);

    // Lookup number of assets in the current assetType
    const typeDetails = this.props.assetTypes.find(
      type => type.type === this.props.assetType
    );
    let assetCount = typeDetails ? typeDetails.count : 0;

    // Count the number of blocks inside jobs that match the current assetType
    let blockCount = (this.props.blocks || []).filter(
      block => block.asset_type === this.props.assetType
    ).length;

    const { filter } = this.props;

    if (filter.filterBy === 'assetAttribute' && this.props.distribution) {
      blockCount = Object.keys(this.props.distribution).length;
      assetCount = Object.values(this.props.distribution).reduce(
        (totalAssets, key) => totalAssets + key.total,
        0
      );
    }
    return (
      <Card className="class-details" hasNoHeader>
        <div className="class-details-container slds-grid slds-gutters">
          <div className="class-performance slds-col slds-size_1-of-2">
            <div className="details-header">
              <h2 className="header">
                {filter.filterBy !== 'assetAttribute' ? (
                  <FormattedMessage id="components.ecs.analytics.classDetails.classPerformance.header" />
                ) : (
                  <FormattedMessage id="components.ecs.analytics.attributeDetails.attributeOverview.header" />
                )}
              </h2>
            </div>
            <div className="class-performance-content slds-grid slds-gutters">
              <div className="slds-col slds-size_1-of-3">
                <div className="stat-block">
                  <p className="title">
                    <FormattedMessage id="components.ecs.analytics.classDetails.classPerformance.totalAssets" />
                  </p>
                  <p className="count">
                    <FormattedNumber value={assetCount} />
                  </p>
                </div>
                <div className="stat-block">
                  <p className="title">
                    {filter.filterBy !== 'assetAttribute' ? (
                      <FormattedMessage id="components.ecs.analytics.classDetails.classPerformance.blocksUsing" />
                    ) : (
                      <FormattedMessage id="components.ecs.analytics.attributeDetails.totalAttributes" />
                    )}
                  </p>
                  <p className="count">
                    <FormattedNumber value={blockCount} />
                  </p>
                </div>
              </div>
              <div className="slds-col slds-size_2-of-3">
                <ClassDetailsChart
                  assetType={this.props.assetType}
                  {...total}
                />
              </div>
            </div>
          </div>
          <div className="performance-rates slds-col slds-size_1-of-2">
            <ClassStats
              assetType={this.props.assetType}
              assetTypes={this.props.assetTypes}
              summary={this.props.summary}
            />
          </div>
        </div>
      </Card>
    );
  }
}

ClassDetails.propTypes = {
  actions: PropTypes.object,
  assetType: PropTypes.string,
  assetTypes: PropTypes.array,
  details: PropTypes.array,
  distribution: PropTypes.object,
  filter: PropTypes.object.isRequired,
  blocks: PropTypes.array,
  jobs: PropTypes.array,
  summary: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(ClassDetails);
